import { useEffect } from 'react';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

type fieldArrayType = FieldArrayWithId & { [key: string]: any };

/**
 * This hook is responsible for removing uncommitted fieldArray field.
 *
 * On the action: 'Create new' we have to append a new record to the fieldArray
 * to handle its fields correctly. On successful add we set a parameter to true: isCommitted.
 * By doing this we mark the field that it should not be removed after closing the form.
 *
 * We have to remove newly appended and uncommitted fields on
 */
const useRemoveUncommitted = (
  fieldArray: fieldArrayType[],
  isDrawerOpen: boolean,
  remove
) => {
  useEffect(() => {
    if (!isDrawerOpen && fieldArray.length > 0) {
      if (
        Object.prototype.hasOwnProperty.call(
          fieldArray.slice(-1)[0],
          'isCommitted'
        ) &&
        !fieldArray.slice(-1)[0]['isCommitted']
      ) {
        remove(fieldArray.length - 1);
      }
    }
  }, [isDrawerOpen]);
};

export default useRemoveUncommitted;
